import {
  FOLDER_CREATE_REQUEST,
  FOLDER_CREATE_SUCCESS,
  FOLDER_CREATE_FAIL,
  FOLDER_CREATE_RESET,
  FOLDER_LIST_REQUEST,
  FOLDER_LIST_SUCCESS,
  FOLDER_LIST_FAIL,
  FOLDER_BY_OWNER_REQUEST,
  FOLDER_BY_OWNER_SUCCESS,
  FOLDER_BY_OWNER_FAIL,
  FOLDER_UPDATE_REQUEST,
  FOLDER_UPDATE_SUCCESS,
  FOLDER_UPDATE_FAIL,
  FOLDER_UPDATE_RESET,
  FOLDER_DELETE_REQUEST,
  FOLDER_DELETE_SUCCESS,
  FOLDER_DELETE_FAIL,
  FOLDER_INITIALIZE_REQUEST,
  FOLDER_INITIALIZE_SUCCESS,
  FOLDER_INITIALIZE_FAIL,
  FOLDER_REORDER_REQUEST,
  FOLDER_REORDER_SUCCESS,
  FOLDER_REORDER_FAIL,
  FOLDER_REORDER_RESET,
} from '../constants/folderConstants';

// Folder creation reducer
export const folderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case FOLDER_CREATE_REQUEST:
      return { loading: true };
    case FOLDER_CREATE_SUCCESS:
      return { loading: false, success: true, folder: action.payload };
    case FOLDER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case FOLDER_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Folder list reducer
export const folderListReducer = (state = { folders: [] }, action) => {
  switch (action.type) {
    case FOLDER_LIST_REQUEST:
      return { ...state, loading: true }; // Keep existing folders during loading
    case FOLDER_LIST_SUCCESS:
      console.log('📥 Folder list success - updating state with:', action.payload?.map(f => ({ id: f._id, name: f.name, sortOrder: f.sortOrder })));
      return { loading: false, folders: action.payload };
    case FOLDER_LIST_FAIL:
      return { ...state, loading: false, error: action.payload }; // Keep existing folders on error
    case FOLDER_CREATE_SUCCESS:
      // Optimistically add the new folder to the list
      const newFolder = action.payload;
      const existingFolders = state.folders || [];
      // Check if folder already exists to avoid duplicates
      const folderExists = existingFolders.some(f => f._id === newFolder._id);
      if (!folderExists) {
        console.log('➕ Adding new folder to list:', { id: newFolder._id, name: newFolder.name });
        return { ...state, folders: [...existingFolders, newFolder] };
      }
      return state;
    case FOLDER_REORDER_SUCCESS:
      // Update folders when reorder succeeds
      console.log('🔄 Folder reorder success - updating state with:', action.payload?.map(f => ({ id: f._id, name: f.name, sortOrder: f.sortOrder })));
      return { ...state, folders: action.payload };
    default:
      return state;
  }
};

// Folders by owner reducer
export const folderByOwnerReducer = (state = { folders: [] }, action) => {
  switch (action.type) {
    case FOLDER_BY_OWNER_REQUEST:
      return { ...state, loading: true }; // Keep existing folders during loading
    case FOLDER_BY_OWNER_SUCCESS:
      return { loading: false, folders: action.payload };
    case FOLDER_BY_OWNER_FAIL:
      return { ...state, loading: false, error: action.payload }; // Keep existing folders on error
    case FOLDER_CREATE_SUCCESS:
      // Optimistically add the new folder to the list if it belongs to this owner
      const newFolder = action.payload;
      const existingFolders = state.folders || [];
      // Check if folder already exists to avoid duplicates
      const folderExists = existingFolders.some(f => f._id === newFolder._id);
      if (!folderExists) {
        console.log('➕ Adding new folder to owner list:', { id: newFolder._id, name: newFolder.name });
        return { ...state, folders: [...existingFolders, newFolder] };
      }
      return state;
    case FOLDER_REORDER_SUCCESS:
      // Update folders when reorder succeeds
      return { ...state, folders: action.payload };
    default:
      return state;
  }
};

// Folder update reducer
export const folderUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case FOLDER_UPDATE_REQUEST:
      return { loading: true };
    case FOLDER_UPDATE_SUCCESS:
      return { loading: false, success: true, folder: action.payload };
    case FOLDER_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case FOLDER_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Folder delete reducer
export const folderDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case FOLDER_DELETE_REQUEST:
      return { loading: true };
    case FOLDER_DELETE_SUCCESS:
      return { loading: false, success: true };
    case FOLDER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Initialize default folders reducer
export const folderInitializeReducer = (state = {}, action) => {
  switch (action.type) {
    case FOLDER_INITIALIZE_REQUEST:
      return { loading: true };
    case FOLDER_INITIALIZE_SUCCESS:
      return { loading: false, success: true, folders: action.payload };
    case FOLDER_INITIALIZE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Folder reorder reducer
export const folderReorderReducer = (state = {}, action) => {
  switch (action.type) {
    case FOLDER_REORDER_REQUEST:
      return { loading: true };
    case FOLDER_REORDER_SUCCESS:
      return { loading: false, success: true, folders: action.payload };
    case FOLDER_REORDER_FAIL:
      return { loading: false, error: action.payload };
    case FOLDER_REORDER_RESET:
      return {};
    default:
      return state;
  }
};
